import { useParams } from "react-router";
import { MODELS, useMultiModel } from "../../api";
import { ShellContent } from "../shell/Shell.jsx";
import tokens from "../../design-system/tokens.js";
import Header from "../../design-system/components/Header/Header.jsx";
import Layout from "../../design-system/components/Layout/Layout.jsx";
import { ItemList } from "./components/ItemList/ItemList.jsx";
import styles from "./library.css";

/**
 * Renders the LibraryOverviewWithData component, which displays a library overview page.
 * This component handles the rendering of a header, a conditional library content section,
 * and dynamically renders a list of items if provided. If no items exist, it displays a
 * fallback message indicating the absence of library content.
 *
 * @function LibraryOverviewWithData
 * @param {Object} props - The properties object.
 * @param {Array} props.items - An array of library items to be displayed. If the array
 *                              is empty or not provided, a default message is shown.
 * @param {Object} props.spark - An object representing the selected spark context used
 *                               for rendering items.
 * @param {Object} props.sparksInfo - Additional information or metadata related to the sparks.
 * @returns {JSX.Element} The rendered library overview page.
 */
const LibraryOverviewWithData = ({ items, spark, sparksInfo }) => {
  return (
    <>
      <Layout
        Header={() => (
          <Header title={"Bibliothek"} back backPath={".."} isDarkMode />
        )}
        hasLibrary={true}
        isDarkMode={true}
      >
        {items &&
          (items.length === 0 ? (
            <div className={styles.noLibraryItemsText}>
              Keine Inhalte in der Bibliothek
            </div>
          ) : (
            <ItemList items={items} spark={spark} sparksInfo={sparksInfo} />
          ))}
      </Layout>
    </>
  );
};

/**
 * Represents the LibraryOverview component, responsible for displaying a library overview
 * page for a specific spark and workshop. It fetches related data, such as library items,
 * spark information,*/
const LibrayOverview = () => {
  const { sparkSlug } = useParams();
  const [items, spark] = useMultiModel([
    MODELS.LIBRARY_ITEMS,
    MODELS.SPARK({ slug: sparkSlug }),
  ]);

  return (
    <ShellContent bg={tokens.color.full.gray800}>
      <LibraryOverviewWithData items={items} spark={spark} />
    </ShellContent>
  );
};

export default LibrayOverview;
